var chunkMapping = {
	"344": [
		50344
	],
	"396": [
		20396
	],
	"2345": [
		12345
	],
	"2625": [
		72625
	],
	"7228": [
		27228
	],
	"8579": [
		88579
	],
	"8713": [
		38713
	],
	"9228": [
		19228
	]
};
var idToExternalAndNameMapping = {
	"12345": [
		"default",
		"./WorkspaceMgmtRoutes",
		38960
	],
	"19228": [
		"default",
		"./UserProfile",
		18081
	],
	"20396": [
		"default",
		"./Module",
		64921
	],
	"27228": [
		"default",
		"./FileMgmtRoutes",
		76800
	],
	"38713": [
		"default",
		"./AssistantWidget",
		59395
	],
	"50344": [
		"default",
		"./GlobalNavigation",
		90767
	],
	"72625": [
		"default",
		"./AiOverviewWidget",
		44324
	],
	"88579": [
		"default",
		"./UserEventsPanel",
		90140
	]
};
var idToRemoteMap = {
	"12345": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 38960
		}
	],
	"19228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 18081
		}
	],
	"20396": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 64921
		}
	],
	"27228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 76800
		}
	],
	"38713": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59395
		}
	],
	"50344": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 90767
		}
	],
	"72625": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 44324
		}
	],
	"88579": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 90140
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}